const ParamsValidationError = require('../errors/ParamsValidationError');

const REQUIRED_FIELDS_MISSING_ERROR_PREFIX = 'Some required fields were\'nt provided: ';
const INCORRECT_TYPE_ERROR_PREFIX = 'Incorrect fields types, expected: ';
const NO_EXPECTED_KEYS_MATCH_ERROR = 'No expected keys match found';
const CONNECT_PARAMS_VALIDATION = {
    appKey: {
        mandatory: true,
        type: 'string'
    },
    cluster: {
        mandatory: true,
        type: 'string'
    },
    logger: {
        mandatory: false,
        type: 'function'
    }
};

const SUBSCRIBE_PARAMS_VALIDATION = {
    channelName: {
        mandatory: true,
        type: 'string'
    }
};

const SUBSCRIBE_TO_CLIENT_EVENTS_CHANNEL_PARAMS_VALIDATION = {
    channelName: {
        mandatory: true,
        type: 'string'
    }
};

const CONNECTION_STATE_CHANGE_PARAMS_VALIDATION = {
    callback: {
        mandatory: true,
        type: 'function'
    }
};

const SIGN_CHANNEL_NAME_PAREMS_VALIDATION = {
    channelName: {
        mandatory: true,
        type: 'string'
    },
    encryptionKey: {
        mandatory: true,
        type: 'string'
    }
};

class ParamsValidator {

    static validate(params, validationParamsKey) {
        const requiredFields = [];
        const incorrectTypeFields = [];
        let errorMessage = '';

        const expected = ParamsValidator.getExpectedParamsMetadata(validationParamsKey);
        if (!expected) {
            throw new ParamsValidationError(NO_EXPECTED_KEYS_MATCH_ERROR);
        }

        if (!params) {
            for (const key in expected) {
                if (expected[key].mandatory) {
                    requiredFields.push(key);
                }
            }

            return `${REQUIRED_FIELDS_MISSING_ERROR_PREFIX}${requiredFields.join(', ')}`;
        }

        for (const key in expected) {
            if (!params[key] && expected[key].mandatory) {
                requiredFields.push(key);
            }

            if (params[key] && typeof(params[key]) !== expected[key].type) {
                incorrectTypeFields.push(`${key}:${expected[key].type}`);
            }
        }

        if (requiredFields.length) {
            errorMessage = `${REQUIRED_FIELDS_MISSING_ERROR_PREFIX}${requiredFields.join(', ')}`;
        }

        if (incorrectTypeFields.length) {
            errorMessage = `${errorMessage}${INCORRECT_TYPE_ERROR_PREFIX}${incorrectTypeFields.join(', ')}`;
        }

        return errorMessage;
    }

    static getExpectedParamsMetadata(validationParamsKey) {
        switch (validationParamsKey){
            case 'connect':
                return CONNECT_PARAMS_VALIDATION;
            case 'subscribe':
                return SUBSCRIBE_PARAMS_VALIDATION;
            case 'subscribeToClientEventsChannel':
                return SUBSCRIBE_TO_CLIENT_EVENTS_CHANNEL_PARAMS_VALIDATION;
            case 'state':
                return CONNECTION_STATE_CHANGE_PARAMS_VALIDATION;
            case 'sign':
                return SIGN_CHANNEL_NAME_PAREMS_VALIDATION;
            default:
        }
    }
}

module.exports = ParamsValidator;
